<template>
  <v-menu
    v-model="isPickerActive"
    :close-on-content-click="false"
    :nudge-right="40"
    transition="scale-transition"
    offset-y
    min-width="290px">
    <template
      v-slot:activator="{ on }">
      <v-text-field
        :outlined="outlined"
        v-model="dateFormatted"
        :label="renderLabel"
        :class="renderClasses"
        readonly
        :dense="dense"
         v-on="readonly ? void 0 : on" />
    </template>
    <v-date-picker
      v-model="val"
      locale="de-de"
      ref="picker"
      :max="new Date().toISOString().substr(0, 10)"
      :first-day-of-week="1"
      @input="isPickerActive = false" />
  </v-menu>
</template>

<script>
// value is a unix timestamp here.

import InputMixin from './mixins/InputMixin'

import { parseISO, isValid, format } from 'date-fns'
import * as localeDE from 'date-fns/locale/de/index.js'

export default {
  name: '',

  mixins: [
    InputMixin
  ],

  data () {
    return {
      isPickerActive: false
    }
  },

  watch: {
    isPickerActive (val) {
      val
        ? this.$nextTick(_ => {
          this.$refs && this.$refs.picker
            ? this.$refs.picker.activePicker = 'YEAR'
            : void 0
        })
        : void 0
    }
  },

  computed: {
    dateFormatted () {
      return this.val !== void 0
        ? format(new Date(this.val), 'd. MMMM yyyy', { locale: localeDE })
        : void 0
    }
  },

  methods: {
    isValueTypeValid (value) {
      return isValid(parseISO(value))
    }
  }
}
</script>
